import styled from "styled-components";
import {SideMenuItemsListDefaultBox} from "./side-menu-items-list.default.box";

export const SideMenuItemsListWSOPBox = styled(SideMenuItemsListDefaultBox)`
    background-color: ${({theme}) => theme.colors.background};
    margin: 2rem 0 0 0;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
        margin: 1rem 0 0 0;
    }
`;
